module.exports = {"652223100":"伊吾镇","652223101":"淖毛湖镇","652223102":"盐池镇","652223201":"苇子峡乡","652223202":"下马崖乡","652223204":"吐葫芦乡","652223205":"前山哈萨克民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652223.json
// module id = 3070
// module chunks = 0